import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oshaprocedure',
  templateUrl: './oshaprocedure.component.html',
  styleUrls: ['./oshaprocedure.component.css']
})
export class OshaprocedureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
